import { ENV } from '@/constants';

export const schemaObject_AiHairstyle = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/hairstyle-changer',
			name: 'AI Hairstyle Changer | Lift',
			description:
				'Try on new hairstyles with AI in seconds. No watermark. Create yours with Lift now.',
			url: 'https://liftapp.ai/hairstyle-changer',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/hairstyle-changer#product' },
				{ '@id': 'https://liftapp.ai/hairstyle-changer#howto' },
				{ '@id': 'https://liftapp.ai/hairstyle-changer#benefits' },
				{ '@id': 'https://liftapp.ai/hairstyle-changer#faq' },
				{ '@id': 'https://liftapp.ai/hairstyle-changer#why-lift' },
				{ '@id': 'https://liftapp.ai/hairstyle-changer#explore-tools' },
				{ '@id': 'https://liftapp.ai/hairstyle-changer#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/hairstyle-changer#product',
			name: 'AI Hairstyle Changer',
			description:
				'Try on new hairstyles with AI in seconds. No watermark. Create yours with Lift now.',
			url: 'https://liftapp.ai/hairstyle-changer',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/hairstyle-changer#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Watch the AI swap work its magic',
					text: 'Our AI scans your face, keeps every detail, and swaps your hair with natural, studio-quality styles',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/hairstyle-changer#benefits',
			name: 'Who can benefit from AI Hairstyle Changer?',
			description: '',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Perfect for anyone curious about changing their look without the salon visit',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'People considering a haircut or color can preview styles before making the change',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Content creators and streamers can get eye-catching avatars for Twitch, YouTube, or social media',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Friends can have fun generating playful, shareable hairstyle swaps for social media',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Delivers quick, realistic results — ideal for both personal style checks and viral fun',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.148840af.webp',
				name: 'x',
				description: '',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/hairstyle-changer#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Hair Style?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Hair Style is an online tool that transforms your selfies into detailed anime-style portraits — perfect for avatars, social media, or creative projects.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Hair Style work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Our AI analyzes your photo with deep learning, keeps your facial features accurate, and reimagines them in anime style with artistic backgrounds, colors, and details. Everything is automatic — no manual editing needed.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will it keep my face and details recognizable?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Hair Style uses advanced face-mapping so your anime version looks just like you — only in a stylized, hand-drawn form. Your hair, eyes, and expressions stay consistent and true.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/hairstyle-changer#why-lift',
			name: 'Why Lift’s AI Hair Style stands out',
			description:
				'Discover how Lift’s AI-powered Anime Generator delivers professional results with smart, affordable, and cross-platform support.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.db565f5c.webp',
				name: 'Anime-style father and son as pirates',
				description:
					'Father and son anime transformation posing like cheerful pirates on a ship',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/hairstyle-changer#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 1,
					name: 'AI Ghibli generator',
					url: 'https://liftapp.ai/ai-filters-ghibli',
					description:
						'Transform your photo into a Ghibli-style cartoon with AI.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 2,
					name: 'AI LEGO generator',
					url: 'https://liftapp.ai/ai-filters-lego',
					description: 'Turn your image into a LEGO-style illustration.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 3,
					name: 'AI Starter Pack generator',
					url: 'https://liftapp.ai/ai-filters-starter-pack',
					description:
						'Apply a modern stylized look with the Starter Pack aesthetic.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 4,
					name: 'AI Object Remover',
					url: 'https://liftapp.ai/background-remover',
					description:
						'Remove unwanted objects or people from your photos with AI in seconds.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 5,
					name: 'AI Background Remover',
					url: 'https://liftapp.ai/background-remover',
					description: 'Erase and replace backgrounds in one click.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 6,
					name: 'AI Image Enhancer',
					url: 'https://liftapp.ai/image-enhancer',
					description: 'Enhance photo quality.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 7,
					name: 'AI Image Upscaler',
					url: 'https://liftapp.ai/image-upscaler',
					description:
						'Increase image resolution to HD without losing quality.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 8,
					name: 'AI Image Generator',
					url: 'https://liftapp.ai/image-gen',
					description:
						'Generate original artwork or portraits using text prompts.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 9,
					name: 'AI Headshot Generator',
					url: 'https://liftapp.ai/headshot-generator',
					description: 'Create a professional headshot with AI.',
				},
				{
					'@type': 'SoftwareApplication',
					operatingSystem: 'Web',
					applicationCategory: 'MultimediaApplication',
					position: 10,
					name: 'AI Watermark Remover',
					url: 'https://liftapp.ai/watermark-remover',
					description: 'Remove watermark from image with AI.',
				},
			],
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/hairstyle-changer#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in/?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Object Remover',
					item: 'https://liftapp.ai/hairstyle-changer',
				},
			],
		},
	],
};
